/*
 * reveal-vinyle.js
 * Déclenche l'apparition « bac à vinyles » (reveal-vinyle.css) quand une
 * carte produit entre à l'écran, une seule fois par carte.
 *
 * - IntersectionObserver : tient compte du recadrage des carrousels, donc une
 *   carte hors champ à droite n'apparaît que quand on la fait défiler.
 * - Cascade : les cartes qui entrent dans le même lot sont décalées de 60 ms,
 *   dans l'ordre d'affichage, plafonné à 0,36 s.
 * - MutationObserver : le chargement continu (infinite-scroll.js) et les
 *   filtres (facets.js) ajoutent ou remplacent des cartes après coup.
 */
(function () {
  window.rpBacOk = true;
  var html = document.documentElement;
  var CIBLES = '#product-grid .product-card-wrapper, .vitrine .product-card-wrapper';

  function liberer() {
    html.classList.remove('rp-bac-pret');
  }

  if (!('IntersectionObserver' in window) || !html.classList.contains('rp-bac-pret')) {
    liberer();
    return;
  }

  var observateur = new IntersectionObserver(
    function (entrees) {
      var visibles = entrees
        .filter(function (e) {
          return e.isIntersecting;
        })
        .sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left;
        });

      visibles.forEach(function (e, i) {
        var carte = e.target;
        carte.style.setProperty('--rp-bac-delai', Math.min(i * 60, 360) + 'ms');
        carte.classList.add('rp-bac--vu');
        observateur.unobserve(carte);
      });
    },
    { threshold: 0, rootMargin: '0px 0px 15% 0px' }
  );

  function balayer(racine) {
    (racine || document).querySelectorAll(CIBLES).forEach(function (carte) {
      if (carte.dataset.rpBac) return;
      carte.dataset.rpBac = '1';
      observateur.observe(carte);
    });
  }

  var attente = false;
  new MutationObserver(function () {
    if (attente) return;
    attente = true;
    requestAnimationFrame(function () {
      attente = false;
      balayer();
    });
  }).observe(document.body, { childList: true, subtree: true });

  balayer();
})();
